/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthorization } from './PalAuthorization';
import {
    PalAuthorizationFromJSON,
    PalAuthorizationFromJSONTyped,
    PalAuthorizationToJSON,
} from './PalAuthorization';

/**
 * 
 * @export
 * @interface FindAllPalAuthorizations200Response
 */
export interface FindAllPalAuthorizations200Response {
    /**
     * 
     * @type {Array<PalAuthorization>}
     * @memberof FindAllPalAuthorizations200Response
     */
    data?: Array<PalAuthorization>;
}

/**
 * Check if a given object implements the FindAllPalAuthorizations200Response interface.
 */
export function instanceOfFindAllPalAuthorizations200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllPalAuthorizations200ResponseFromJSON(json: any): FindAllPalAuthorizations200Response {
    return FindAllPalAuthorizations200ResponseFromJSONTyped(json, false);
}

export function FindAllPalAuthorizations200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalAuthorizations200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(PalAuthorizationFromJSON)),
    };
}

export function FindAllPalAuthorizations200ResponseToJSON(value?: FindAllPalAuthorizations200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(PalAuthorizationToJSON)),
    };
}

